import http from '../http-common';
import store from '../store';

class APIService {
    fetch ({ method, path, data }) {
		let response =  new Promise(function(resolve/*, reject*/) {
			let intervalID = setInterval(function () {
				const api = store.state.env.get('VUE_APP_API_LINK');
				if ( api !== undefined ) {				
					clearInterval(intervalID)
					http.defaults.baseURL = api;

					let response;
					
					switch (method) {			
						case 'post':
							response = http.post(path, data).catch(funcError);
							break;
			
						case 'put':
							response = http.put(path, data).catch(funcError);
							break;
			
						case 'delete':
							response = http.delete(path).catch(funcError);
							break;
			
						default:
							response = http.get(path).catch(funcError);
					}

					resolve(response);
				}
			}, 100);

		});

		return response;
	}
}

const funcError = (error) => {
	if(!error.response)
	{
		return false;
	}
	switch (error.response.status) {
		case 401:
			window.location.href = store.getters.env.get('VUE_APP_LIVELAPS_HOST') + '/login';
			break
		default:
			break
	}
};

export default new APIService();